import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const WorldToursMovementTypes = () => import('@/pages/world-tours/movementTypes.vue');

export default [
  {
    path: '/world-tours/movement-types',
    name: 'WorldToursMovementTypes',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Типы передвижения',
      ],
    },
    component: WorldToursMovementTypes,
  },
  {
    path: '/world-tours/movement-types/:id',
    name: 'WorldToursMovementTypesForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Экскурсии мир',
        'Типы передвижения',
      ],
    },
    component: WorldToursMovementTypes,
  },
];
